import { twJoin } from "tailwind-merge";

import {
  DASHBOARD_GRID_CLASS,
  DASHBOARD_GRID_COLUMNS_STYLE,
  GRID_COLUMNS,
} from "src/analytics/dashboard/dashboardGridLayout";

export const DashboardBackgroundGrid: React.FC<{ rows: number }> = ({
  rows,
}) => (
  <div
    className={twJoin(
      "pointer-events-none absolute inset-0 z-0",
      DASHBOARD_GRID_CLASS,
    )}
    data-loc="dashboard-background-grid"
    style={DASHBOARD_GRID_COLUMNS_STYLE}
  >
    {Array.from({ length: GRID_COLUMNS * rows }).map((_, index) => (
      <div key={index} className="h-full rounded-md bg-gray-50" />
    ))}
  </div>
);
